import { render, staticRenderFns } from "./UnclosedInvoices.vue?vue&type=template&id=744a8614"
import script from "./UnclosedInvoices.vue?vue&type=script&lang=js"
export * from "./UnclosedInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports